import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";

import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

export interface OrderRequest {
    customer_idx: number;
    customer_name: string; //고객 이름
    order_name: string; //주문자 명
    order_mobile: string;
    product_idx: number;
    wreath_sender: string; //명의
    wreath_word: string; //경조사어
    recipient_name: string; //수신자명
    recipient_mobile: string; //수신자 연락처
    is_union: boolean; //노동조합 여부
    event_content_idx: number; //경조내용 index
    event_content: string;
    related_person: string; //대상자명(관계자명)
    work_location: string; //근무지
    department: string; //부서
    company_tel: string; //사번
    delivery_immediate: boolean; //즉시 배송 여부
    delivery_date: string; //배송일자 (YYYY-MM-DD)
    delivery_time: string; //배송 시간
    delivery_post: string; //배송지 우편번호
    delivery_address: string; //배송 주소
    delivery_address_detail: string; //배송 상세 주소
    delivery_memo_idx: number; //배송 메모 index
    delivery_memo: string; //배송 메모
    file_memo: string; //초대장, 청첩장, 부고장 정보 메모
    order_memo: string; //주문 메모
    order_file: File[]; //초대장, 청첩장, 부고장 정보 파일 (최대 4장)
}

interface OrderResponse {
    data: {
        order_idx: number;
    };
}

const createFormData = (data: OrderRequest) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof OrderRequest];

        if (key === "order_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("order_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePostOrder = (): UseMutationResult<OrderResponse, Error, OrderRequest, unknown> => {
    // const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    const headers = {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        },
    };

    return useMutation<OrderResponse, Error, OrderRequest>({
        mutationFn: async (orderData: OrderRequest) => {
            const formData = createFormData(orderData);
            const response = await axios.post(
                enum_api_uri.user.post_order,
                formData,
                accessToken ? { ...headers } : { headers: { "Content-Type": "multipart/form-data" } },
            );
            return response.data;
        },
        onSuccess: data => {
            return data;
        },
    });
};
